import { render, staticRenderFns } from "./addAppRegister.vue?vue&type=template&id=250a5e74&scoped=true"
import script from "./addAppRegister.vue?vue&type=script&lang=js"
export * from "./addAppRegister.vue?vue&type=script&lang=js"
import style0 from "./addAppRegister.vue?vue&type=style&index=0&id=250a5e74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250a5e74",
  null
  
)

export default component.exports